import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var User = createReactComponent("User", ["svg", defaultAttributes, [["path", {
  d: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2",
  key: "kk2qn1"
}], ["circle", {
  cx: "12",
  cy: "7",
  r: "4",
  key: "1p8uz1"
}]]]);
export default User;